export default __webpack_public_path__ + "static/media/Inspection_job_report_white.bb72916b.svg";